import React, { useState } from 'react';
import Box from '@Atoms/Box';
import Button from '@Atoms/Button';
import ShowIf from '@Atoms/ShowIf';
import { useAvailableTests, useGetLearnosityExamTestSessions } from '../../hooks';
import { MappedTestSession } from '../../types';
import ModifyTestSessionCard from './ModifyTestSessionCard';
import mapTestSessions from '../../utils/mapTestSessions';
import TestSessionDialog from './TestSessionDialog';

const ManageTestSessions = () => {
  const { data: testSessions } = useGetLearnosityExamTestSessions();
  const { data: availableTests } = useAvailableTests();
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [selectedTestSession, setSelectedTestSession] =
    useState<MappedTestSession | null>(null);

  const testSessionData = mapTestSessions(testSessions) as MappedTestSession[];
  const canAddExtraFromPolicy = testSessionData[0]?.can_add_extra_sessions ?? true;

  const canAddExtraTestSession =
    canAddExtraFromPolicy &&
    !!availableTests?.length &&
    availableTests.length > testSessionData?.length;

  const handleSetSelectedTestSession = (testSession: MappedTestSession) => {
    setSelectedTestSession(testSession);
  };

  const handleClose = () => {
    setSelectedTestSession(null);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {testSessionData?.map((testSession) => (
          <ModifyTestSessionCard
            key={testSession.id}
            testSession={testSession}
            setSelectedTestSession={handleSetSelectedTestSession}
          />
        ))}
      </Box>
      <ShowIf If={!!canAddExtraTestSession}>
        <Button
          variant="outlined"
          onClick={() => setIsAddDialogOpen(true)}
          fullWidth
          size="large"
          sx={{ mt: 2, mb: 2, borderStyle: 'dashed' }}
        >
          Add Test Session
        </Button>
      </ShowIf>
      <TestSessionDialog
        open={isAddDialogOpen}
        mode="add"
        testSession={null}
        siblingSessions={testSessionData}
        onClose={() => setIsAddDialogOpen(false)}
      />
      <TestSessionDialog
        open={!!selectedTestSession}
        mode="edit"
        testSession={selectedTestSession}
        siblingSessions={testSessionData}
        onClose={handleClose}
      />
    </Box>
  );
};

export default ManageTestSessions;
